var app = angular.module('leonardo');

var PmsSyncController = function ($scope, $filter, AccountService, PmsPlatformsService, NotificationService) {
  $scope.accountService = AccountService;
  $scope.pmsPlatformsService = PmsPlatformsService;
  $scope.data = {
    force: false,
    account_id: null,
    pms_id: null
  };

  $scope.platforms = PmsPlatformsService.getAll().$object;

  const deployEnvironment = window.LEO_DEPLOY_ENVIRONMENT;

  const getBrokerName = () => {
    switch (deployEnvironment) {
      case 'prod':
        return `broker-prodp3`;
      case 'staging':
        return `broker_${deployEnvironment}`;
      case 'dev':
        return `broker-DEV`;
      default:
        return `broker-${deployEnvironment}`;
    }
  };

  const getEnvName = () => {
    switch (deployEnvironment) {
      case 'prod':
        return 'prodp3';
      case 'dev':
        return 'DEV';
      default:
        return deployEnvironment;
    }
  };

  $scope.grafanaUrls = [
    `https://monit.leonardo247.com/grafana/d-solo/0Ok3hgrnk/pms-sync-status?orgId=1&panelId=9&theme=light&var-env=${getEnvName()}`,
    `https://monit.leonardo247.com/grafana/d-solo/0Ok3hgrnk/pms-sync-status?orgId=1&panelId=12&theme=light&var-env=${getEnvName()}`,
    `https://monit.leonardo247.com/grafana/d-solo/0Ok3hgrnk/pms-sync-status?orgId=1&panelId=10&theme=light&var-env=${getEnvName()}`,
    `https://monit.leonardo247.com/grafana/d-solo/0Ok3hgrnk/pms-sync-status?orgId=1&panelId=11&theme=light&var-env=${getEnvName()}`,
    `https://monit.leonardo247.com/grafana/d-solo/QAec4mqMz/queue-monitoring?orgId=1&refresh=1m&theme=light&var-queue=default_dl&panelId=11&var-broker=${getBrokerName()}`
  ];

  const getPmsCode = (id) => {
    return $scope.platforms.find((pms) => pms.id == id)?.code;
  };

  $scope.runSync = function () {
    $scope.data.pms_code = getPmsCode($scope.data.pms_id);

    PmsPlatformsService.rumPmsSync($scope.data).then(function () {
      NotificationService.notify('success', $filter('translate')('The requested synchronization is running and will finish shortly.'));
    });
  };
};

app.controller('PmsSyncController', ['$scope', '$filter', 'AccountService', 'PmsPlatformsService', 'NotificationService', PmsSyncController]);
